import { combineReducers } from "@reduxjs/toolkit";

import {
	reportExecutorOrdersReportDataState,
	reportExecutorOrdersReportDataReducer,
	reportExecutorOrdersReportDataAction,
} from "./data";

export type StateExecutorOrdersReport = {
	data: reportExecutorOrdersReportDataState;
};

export const executorOrdersReport = combineReducers<StateExecutorOrdersReport>({
	data: reportExecutorOrdersReportDataReducer,
});

export const reportsExecutorOrdersReportAction = {
	data: reportExecutorOrdersReportDataAction,
};

export default executorOrdersReport;
